export const MAX_PHOTOS_PER_POST = 10;
export const MAX_CAPTION_LENGTH = 2000;
/** Max Locations (accounts) that can be tagged/mentioned on a single social post.
 * See https://www.ayrshare.com/docs/testing/post-verification#mentions for more details.
 */
export const MAX_TAGGED_LOCATIONS = 5;
